import { render } from "./ShowPaymentInfo.vue?vue&type=template&id=1d09514f&scoped=true&lang=pug"
import script from "./ShowPaymentInfo.vue?vue&type=script&lang=ts"
export * from "./ShowPaymentInfo.vue?vue&type=script&lang=ts"

import "./ShowPaymentInfo.vue?vue&type=style&index=0&id=1d09514f&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-1d09514f"

export default script